$(document).ready(function () {
    // chnage tab code
    $(".tab-buttons .tab").on("click", function () {
        const tab_content_value = $(this).data("tab-button");
        $(".tab-buttons .tab").removeClass("active");
        $(this).addClass("active");
        $(".tab-content").removeClass("active");
        $('[data-tab-content="' + tab_content_value + '"]').addClass("active");
    });
    // chnage font code
    $(".font-buttons .font-btn").on("click", function () {
        var font_family = $(this).data("font-family");
        $(".engraving-input,.engraving-text").attr("data-font-family", font_family);
        $(".font-buttons .font-btn").removeClass("active");
        $(this).addClass("active");
        sessionStorage.setItem(`font-family`, font_family);
    });
    function update_character_len($_this) {
        const input_len = $_this.val().length;
        const input_max_len = $_this.attr("maxlength");
        const remaning_len = parseInt(input_max_len) - parseInt(input_len);
        console.log('rahul');
        $_this
            .closest(".engraving-input")
            .find(".text-len span")
            .text(remaning_len);
    }
    function changeEngravingData() {
        let engraving_html = "";
        $(".engraving-inputs .engraving-input").each(function (index) {
            if ($(this).is(":visible")) {
            var input_data = $(this).find("input").val();
            sessionStorage.setItem(`input-${index}`, input_data);
            engraving_html += `<p>${input_data}</p>`;
            }
        });
        $(".engraving-text").html(engraving_html);
    }
    // change input field
    $(".engraving-inputs input").on("keyup", function () {
        changeEngravingData();
      // update_character_len($(this));
    });
    const its_so_you_product = sessionStorage.getItem("its-so-you-product");
    const engraving_input1 = sessionStorage.getItem("input-0");
    const engraving_input2 = sessionStorage.getItem("input-1");
    const font = sessionStorage.getItem("font-family");
    const product_url = window.location.href;
    console.log(product_url);
    if (product_url.indexOf(its_so_you_product) > -1) {
        $("#engrav-input-1").val(engraving_input1);
        $("#engrav-input-2").val(engraving_input2);
        $('[data-font-family="' + font + '"]').click();
        changeEngravingData();
    }
});  